import api from './apiClient';

export const mediaAPI = {
  async uploadEventImage(file) {
    const payload = new FormData();
    payload.append('file', file);

    try {
      return await api.post('/media/event-image', payload, {
        headers: {
          'Content-Type': undefined,
        },
      });
    } catch (error) {
      console.error('Event image upload error:', error);
      throw error;
    }
  },
};

export default mediaAPI;

